// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"295":"dffca78e","641":"05cb51eb","825":"be5ccd4d"}[chunkId] + ".css";
};